// Copyright (c) Meta Platforms, Inc. and affiliates.

'use client';

/**
 * @file CheckboxListContext.tsx
 * @input Uses React createContext
 * @output Exports CheckboxListContext for parent-child communication
 * @position Internal context; consumed by CheckboxList.tsx and CheckboxListItem.tsx
 */
import { createContext } from 'react';
export const CheckboxListContext = /*#__PURE__*/createContext(null);
CheckboxListContext.displayName = 'CheckboxListContext';